import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";

export function useEverifyUserProfile(enabled) {
  return useQuery({
    queryKey: ["everifyUserProfile"],
    queryFn: async () => {
      const { data } = await api.get("/authentication/userprofile");
      return data?.result ?? null;
    },
    enabled,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });
}
